import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useLogout } from "../auth/useLogout";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/content-types", label: "Content Types", end: false },
  { to: "/products", label: "Inventory", end: false },
  { to: "/media", label: "Media", end: false },
  { to: "/subscribers", label: "Subscribers", end: false },
  { to: "/settings/integrations", label: "Integrations", end: false },
] as const;

export function Layout() {
  const auth = useAuth();
  const logout = useLogout();
  const [loggingOut, setLoggingOut] = useState(false);

  const email = auth.email || "Signed in";

  const onLogout = () => {
    setLoggingOut(true);
    void logout();
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <span className="sidebar__brand-mark" aria-hidden="true">
            E
          </span>
          <span className="sidebar__brand-text">EAUB CMS</span>
        </div>
        <nav className="sidebar__nav" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? "sidebar__link sidebar__link--active" : "sidebar__link"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__footer">Enterprise Headless CMS</div>
      </aside>

      <div className="main-area">
        <header className="topbar">
          <div className="topbar__spacer" />
          <div className="topbar__user">
            <span className="topbar__email" title={email}>
              {email}
            </span>
            <button
              type="button"
              className="btn btn--secondary btn--sm"
              onClick={onLogout}
              disabled={loggingOut}
            >
              {loggingOut ? "Logging out…" : "Logout"}
            </button>
          </div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
